import React from 'react';
import { SchemaHelpers } from '../../helpers';
import { Schema } from './Schema';
export var SchemaProperties = function (_a) {
    var _b, _c, _d;
    var schema = _a.schema;
    if (!schema) {
        return null;
    }
    var properties = Object.entries((_b = schema.properties()) !== null && _b !== void 0 ? _b : {});
    var patternProperties = Object.entries((_c = schema.patternProperties()) !== null && _c !== void 0 ? _c : {});
    if (!properties.length && !patternProperties.length) {
        return null;
    }
    var required = (_d = schema.required()) !== null && _d !== void 0 ? _d : [];
    return (React.createElement(React.Fragment, null,
        properties.map(function (_a) {
            var propertyName = _a[0], property = _a[1];
            return (React.createElement(Schema, { key: propertyName, schema: property, schemaName: propertyName, required: required.includes(propertyName), isProperty: true, isCircular: property.isCircular(), dependentRequired: SchemaHelpers.getDependentRequired(propertyName, schema) }));
        }),
        patternProperties.map(function (_a) {
            var propertyName = _a[0], property = _a[1];
            return (React.createElement(Schema, { key: propertyName, schema: property, schemaName: propertyName, isPatternProperty: true, isProperty: true, isCircular: property.isCircular() }));
        })));
};
//# sourceMappingURL=SchemaProperties.js.map